import { UserPushPermissionSummary } from '@mygate/common';
import { formatDateTime } from './date';

/** " (last reported <date>)" or "" — the freshness stamp shown next to a permission verdict. */
export function lastReportedSuffix(permission: UserPushPermissionSummary | null): string {
  return permission?.reportedAt ? ` (last reported ${formatDateTime(permission.reportedAt)})` : '';
}

/**
 * Why a user has no registered push device, as far as the app's last permission report tells.
 * Used by every backoffice surface that lists a user's devices so they all give the same verdict.
 */
export function noDevicesDescription(permission: UserPushPermissionSummary | null): string {
  switch (permission?.status) {
    case 'denied':
      return `No devices registered — notifications are blocked in the phone's system settings${lastReportedSuffix(permission)}`;
    case 'granted':
      return `No devices registered — OS permission granted but the app never registered a token${lastReportedSuffix(permission)}`;
    default:
      return 'No devices registered';
  }
}
